<template lang="pug">
div.scene
  .topTitle
    span {{form.departmentName || '现场调研'}}
    .btns
      span.span(@click='chagneImage') 更换场景
      Icon(type="md-arrow-dropup",@click="$emit('upData',eachIndex,DATA,)")
      Icon(type="md-arrow-dropdown",@click="$emit('downData',eachIndex,DATA)")
      Icon(type="md-git-branch",@click='logic')
      Icon(type="ios-trash",@click='delModel')
  .talkImg
    img(:src="getImgPath(1)")
  .plan
    Form(ref="department",:model="form",:label-width="120")
      //- FormItem(label="设置部门名称")
      //-   Select(ref="element",v-model="form.logic" placeholder="选择部门名称" :disabled="JSON.stringify(surveyData) != '{}'" @on-change="handleDe")
      //-     Option(v-for="(item, index) in departmentList",
      //-       :value="item.departmentName",
      //-       :key="item.id",) {{item.departmentName}}
      FormItem(label="选择调研阶段")
        Tooltip(content="需完整填写三个阶段的内容！" placement="top")
          Select(v-model="fun_office" placeholder="选择调研阶段" @on-change="handleT")
            Option(v-for="app in meetData" :key="app.key" :value="app.key") {{ app.value }}
  component(v-for='(item,index) in assemblyList',
    v-if="condition"
    :key='index',
    :assemblyName="assemblyName",
    @delModel='delCom(index)',
    :ref="item.name + index",
      v-disabled="seeState"
    :is='item.name',
    :data='item.data',
    @upData='upData(index)',
    @downData='downData(index)',
    @data1:data="val => item.data = val"
    :tableData.sync="tableData").model
  //- div.drag(@drop="fun_drop",@dragover="allowDrop")
  //-   p  把题型或者案例内容拖入此区域吧!
  Modal.modal1(:value="modal1" :closable='true' width='680' :mask-closable="true" :footer-hide='true',@on-visible-change="choseImg")
    .imglist
      .imgview(
        v-for='(item, index) in unitList'
        :key="item"
        @click='activeImg(item)'
      )
        .mask 场景{{index + 1}}
        div(v-if='item === name' :class='item === name ? "check" : ""') √
        img.img(:src='getImgPath(index)')
</template>
<script>
// import mybus from "@/utils/main";
import Single from "../case/single";
import MultipleA from "../case/multiple";
import MultipleB from "../case/multiple";
import Fillblank from "../case/fillblank";
import EasyQuestion from "../case/easyQuestion";
import Material from "../case/material";
import CaseTitle from "../case/caseTitle";
import CaseAxis from "../case/caseAxis";
import CaseDialogue from "../case/caseDialogue";
import CaseAskAndAnswer from "../case/caseAskAndAnswer";
import CaseGuide from "../case/caseGuide";
import CasePhotoText from "../case/casePhotoText";
import CaseSingleText from "../case/caseSingleText";
import CaseInfoBase from "../case/caseInfoBase";
import CaseDepartment from "../case/caseDepartment";
import CaseUpload from "../case/caseUpload";
import determineQuestion from "../case/determineQuestion";
import ligatureQuestion from "../case/ligatureQuestion";
import TableQuestion from "../case/tableQuestion";
import CaseTitleText from "../case/caseTitleText";
import CaseVideo from "../case/caseVideo";
import MultipeChoice from "../case/multipeChoice";
import Divider from "../case/divider";
import smallCaseTitle from "../case/smallCaseTitle";

/* eslint-disable import/no-dynamic-require */
/* eslint-disable global-require */
import { unitList, caseList } from "./departmentImage";

export default {
  components: {
    Single,
    MultipleA,
    MultipleB,
    Fillblank,
    EasyQuestion,
    Material,
    CaseAxis,
    CaseTitle,
    CaseDialogue,
    CaseAskAndAnswer,
    CaseInfoBase,
    CaseDepartment,
    CaseUpload,
    determineQuestion,
    TableQuestion,
    ligatureQuestion,
    CaseGuide,
    CasePhotoText,
    CaseSingleText,
    CaseTitleText,
    CaseVideo,
    MultipeChoice,
    Divider,
    smallCaseTitle
  },
  inject: ["seeState"],

  props: ["assemblyName", "eachIndex", "selectDepartment1", "data", "info", "fun_office1", "name"],
  data() {
    return {
      condition: true,
      unit: "",
      form: {
        departmentName: "现场调研",
        logic: ""
      },
      department1: "",
      departmentCode: "",
      fun_office: "",
      departmentList: [],
      // caseValue: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      assemblyList: [{ name: "MultipleA", data: {} }], // 拖进来的组件
      unitList,
      caseList,
      meetData: [
        {
          value: "调研对象",
          key: "MultipleA"
        },
        {
          value: "实地勘测",
          key: "CaseGuide"
        },
        {
          value: "疑问咨询",
          key: "CaseAskAndAnswer+CaseInfoBase"
        }
      ],
      modal1: false, /** 场景图 */
      tableData: {}
    };
  },
  watch: {
    tableData: {
      handler(val) {
        this.$emit("updateTableData", val);
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    caseValue() {
      return this.$store.state.Case.caseValue;
    },
    ChId() {
      return this.$store.state.Case.chId;
    },
    getImgPath() {
      return i => {
        if (i || i === 0) {
          return require(`../../assets/case/${this.caseList[i]}.png`);
        }
        const a = require(`../../assets/case/${this.caseList[this.unitList.indexOf(this.name)]
          }.png`);
        // console.log(a, "../../assets/case/");
        return a;
      };
    },
    DATA() {
      return { talkList: this.form, assemblyList: this.assemblyList };
    },
    List() {
      return this.getData;
    },
    taskList() {
      return this.$store.state.task.task;
    },
    infoBase() {
      return this.assemblyList.filter(v => v.name === "CaseInfoBase");
    },
    taskHome() {
      return this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ].taskHome;
    },
    taskInfo() {
      return JSON.parse(sessionStorage.getItem("taskInfo"));
    },
    surveyData() {
      return (
        this.$store.state.Case.caseData[
          this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
        ].task
          .filter(v => v.id === this.taskInfo.id)[0]
          .SceneList.filter(item => item.scene === "SURVEY")[0] || {}
      );
    }
  },
  created() {
    if (this.data) {
      this.assemblyList = this.data.assemblyList || this.data;
    }
    // this.form.departmentName = this.fun_office1;
    this.fun_office = this.fun_office1 || "MultipleA";
  },
  methods: {
    handleDe(val) {
      this.form.departmentName = val;
    },
    async getPersion() {
      console.log(this.$store.state.Case, "this.$store.state.Case");
      try {
        const { data } = await this.$http.listCaseDepartmentStepByChid({
          chId: this.ChId
        });
        console.log(data.data, "调用了data");
        this.departmentList = data.data;
      } catch (error) {
        console.log(error);
      }
    },
    activeImg(unit) {
      this.unit = unit;
      this.modal1 = false;
    },
    /** 点击图片modal */
    choseImg(val) {
      // console.log(val, "this.modal");
      if (!val) {
        this.modal1 = false;
      }
      if (this.unit) {
        const data = {
          type: "unit",
          index: this.eachIndex,
          data: {
            name: this.unit,
            DATA: this.DATA
          }
        };
        this.$emit("changeData", data);
      }
    },
    /** 更换场景modal */
    chagneImage() {
      this.modal1 = true;
      console.log(this.modal1, this.unit, "name", "eachIndex");
    },
    upData(index) {
      // 题目点击向上移动
      if (index === 0) {
        return this.$Message.error("已经是第一个控件啦");
      }
      this.condition = false;

      [this.assemblyList[index], this.assemblyList[index - 1]] = [
        this.assemblyList[index - 1],
        this.assemblyList[index]
      ];
      this.$forceUpdate();
      setTimeout(() => {
        this.condition = true;
      }, 0);
    },
    downData(index) {
      // 题目点击向上移动

      if (index + 1 === this.assemblyList.length) {
        return this.$Message.error("已经是最后一个控件啦");
      }
      this.condition = false;

      [this.assemblyList[index], this.assemblyList[index + 1]] = [
        this.assemblyList[index + 1],
        this.assemblyList[index]
      ];
      this.$forceUpdate();
      setTimeout(() => {
        this.condition = true;
      }, 0);
    },
    // select(value) {
    //   let i;
    //   // 截流
    //   let lock = 0;
    //   this.taskList.forEach(item => {
    //     if (item.departmentName) {
    //       if (item.departmentName === value) {
    //         // 清空内容
    //         this.form.departmentName = "";
    //         this.$refs.element.values = [];
    //         lock = 1;
    //         return this.$Message.error("不可以选择相同的部门");
    //       }
    //     }
    //   });
    //   if (lock > 0) {
    //     return;
    //   }
    //   this.taskHome.forEach(item => {
    //     // console.log(item);
    //     if (item.departmentName === value) {
    //       const obj = {};
    //       obj.departmentName = item.departmentName;
    //       obj.cdId = item.id || item.chId;
    //       i = obj;
    //     }
    //   });
    //   const obj1 = {};
    //   obj1.index = this.eachIndex;
    //   obj1.departmentName = value;
    //   // console.log(i, "oldIs");
    //   this.$emit("info:data", i, this.eachIndex);
    //   this.$store.commit("changeFunc", obj1);
    // },
    getData(data) {
      return data;
    },
    // 删除题目
    delCom(index) {
      // delete this.assemblyList[index];
      if (!this.assemblyList[index].data || !this.assemblyList[index].data.id) {
        this.assemblyList = this.assemblyList.filter((val, i) => i !== index);
        // this.assemblyList.splice(index, 1);
        return;
      }
      if (this.assemblyList[index].data?.id) {
        /** 如果有ID 则需要调用后端接口 */
        this.$store.commit("deleteControl", this.assemblyList[index].data.id);
      }
      // 直接删除
      this.assemblyList.splice(index, 1);
      const obj = {};
      obj.type = this.department1;
      obj.deleteIndex = index;
      this.$store.commit("deleteQues", obj);
    },
    // 删除部门
    delModel() {
      this.$emit("delModel", this.name, this.eachIndex);
      this.$store.commit("setModules", "");
    },
    async handleT(type) {
      let moduleStr = "";
      if (this.fun_office === "MultipleA") {
        moduleStr = await "SURVEY";
      }
      if (this.fun_office === "CaseGuide") {
        moduleStr = await "DETECTION";
      }
      if (this.fun_office === "CaseAskAndAnswer+CaseInfoBase") {
        moduleStr = await "SEEK";
      }
      console.log(type, "执行 type");
      sessionStorage.setItem("isDisabled", true);
      this.$store.commit("setModules", moduleStr);
      if (JSON.stringify(this.surveyData) === "{}") {
        if (type.indexOf("+") !== -1) {
          this.assemblyList = [];
          type.split("+").forEach(v => {
            this.assemblyList.push({ name: v, data: {} });
          });
        } else {
          if (type === "CaseGuide") {
            this.assemblyList = [{ name: "CaseGuide", data: {} }];
          }
          if (type === "MultipleA") {
            this.assemblyList = [{ name: "MultipleA", data: {} }];
          }
        }
      } else {
        this.$http.listTaskScenarioByTaid({ taId: this.taskInfo.id }).then(res => {
          this.$http
            .listControlByTsid({
              tsId: res.data.data.filter(v => v.departmentName === this.form.departmentName)[0].id,
              module: moduleStr
            })
            .then(async val => {
              if (val.data.data.length > 0) {
                if (type.indexOf("+") !== -1) {
                  const { data: infoData } = await this.$http.listMaterials(
                    JSON.parse(sessionStorage.getItem("taskInfo")).id
                  );
                  this.ObtainSubject(val.data.data.concat(infoData.data || []));
                } else {
                  this.ObtainSubject(val.data.data);
                }
              } else {
                this.assemblyList = [];
                if (type.indexOf("+") !== -1) {
                  type.split("+").forEach(v => {
                    this.assemblyList.push({ name: v, data: {} });
                  });
                } else {
                  this.assemblyList = [{ name: type, data: {} }];
                }
              }
            });
        });
      }
    },
    fun_drop() {
      if (this.assemblyName !== "") {
        this.assemblyList.push({ name: this.assemblyName, data: {} });
        const obj = {};
        obj.type = this.department1;
        obj.listChild = this.assemblyName;
        this.$store.commit("addQues", obj);
      }
    },
    allowDrop(e) {
      e.preventDefault();
    }
  },
  async mounted() {
    this.getPersion();
    this.handleT(this.fun_office1 || "MultipleA");
    this.form.departmentName = this.surveyData?.departmentName || "现场调研";
    this.form.logic = this.surveyData?.logicNum || "";
    // this.departmentCode = this.assemblyName;
    this.department1 = this.selectDepartment1;
    // this.departmentList = this.caseValue;
    // this.$store.state.Case.caseData.EXECUTE.taskHome.forEach(res => {
    //   if (
    //     res.departmentName !== "我的办公室" &&
    //     res.departmentName !== "领导办公室" &&
    //     res.departmentName !== "民意调查中心"
    //   ) {
    //     this.departmentList.push(res);
    //   }
    // });
    // mybus.$on(`add${this.eachIndex}`, this.ObtainSubject);
  }
};
</script>

<style lang="stylus">
.scene
  width 854px
  padding 16px 32px 60px 32px
  .topTitle
    text-align left
    height 32px
    line-height @height
    position relative
    margin-bottom 16px
    font-size 14px
    font-weight bold
    color rgba(42, 46, 54, 0.8)
    .btns
      position absolute
      right 0
      top 0
      .span
        padding-right 12px
        cursor pointer
      .ivu-icon
        color #3A76D2FF
        font-size 22px
        top 0
        margin-right 12px
        background #F2F5FAFF
        width 24px
        height 24px
        border-radius 4px
        text-align center
        line-height @height
        &:hover
          cursor pointer
  .talkImg
    margin-bottom 24px
    img
      width 100%
  .plan
    text-align left
    font-size 14px
    border-bottom 1px solid rgba(42, 46, 54, 0.3)
    form
      .ivu-form-item
        .ivu-form-item-label
          text-align left
        .ivu-form-item-content
          .ivu-select
            width 168px
  .drag
    min-width 790px
    height 100px
    background #fff
    border-radius 4px
    border 1px dashed rgba(128, 128, 128, 0.5)
    margin-top 24px
    cursor alias
    p
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(128, 128, 128, 0.5)
      line-height 100px
      text-align center
.modal1
  .imglist
    display flex
    flex-direction row
    flex-wrap wrap
    .imgview
      position: relative;
      width 148px
      height 84px
      cursor pointer
      margin 4px
      .mask
        width 100%
        height 84px
        line-height 84px
        position absolute
        display block
        font-size 14px
        font-family MicrosoftYaHeiUI-Bold, MicrosoftYaHeiUI
        font-weight bold
        color #FFFFFF
        text-align center
        background rgba(0,0,0,0.4)
      .check
        position absolute
        top 5px
        right 5px
        width 20px
        height 20px
        line-height 24px
        background rgb(51,124,246)
        color #ffffff
        text-align center
        border-radius 50%
        border: 1px solid #ffffff;
      .img
        width 100%
        height 100%
      &:hover
        .mask
          display none
</style>
